export function onNextFrame(callback) {
    setTimeout(() => {
        window.requestAnimationFrame(callback);
    }, 0);
}
export function formatNumber(text, decimals = 0, defaultVal = "") {
    if (text === "") {
        return defaultVal;
    }
    const value = parseFloat("" + text);
    if (isNaN(value)) {
        return defaultVal;
    }
    let [whole, decimal] = value.toFixed(decimals).split(".");
    whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    return decimal ? whole + "," + decimal : whole;
}
